import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
const EmployeeDetails = (props) => {
  const [data, setData] = useState([]);
  const [index, setIndex] = useState(0);
  const value = useSelector((state) => state.viewDetails);

  useEffect(() => {
    const result = props.data.map((item) => {
      return {
        ...item,
        ERTDuedate: item.ERTDueDate
          ? moment(new Date(item.ERTDueDate)).format("YYYY-MM-DD")
          : "",
      };
    });

    setData(result);
  }, [props]);

  useEffect(() => {
    setIndex(value.index);
  }, [value]);

  return (
    <>
      {data.length > 0 ? (
        <Grid className="p-10px" container spacing={2}>
          <Grid item xs={4} container>
            <Grid item xs={5}>
              Candidate ID :
            </Grid>
            <Grid item xs={7}>
              {data[index].CandidateId}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Oracle User Name :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {" "}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              TTEC Email :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].TTecEmail}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              First Name :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].FirstName}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Middle Initial :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Last Name:
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].LastName}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Date of Birth:
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Gender :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              International ID (SSN) :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Email Address :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Home Phone :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Mobile Phone :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Address :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Address 2:
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              City of Residency :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              State/Provice :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Zip/Post Code :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Country Code :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Site :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Location ID :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].LocationId}
            </Grid>
          </Grid>
          <Grid item xs={4} container>
            {/* <Grid item xs={5} >CPP code :</Grid>
            <Grid item xs={7}>{data[index].CPPCode}</Grid> */}
            <Grid item xs={5}>
              Client/Program :
            </Grid>
            <Grid item xs={7} sx={{ height: 50, overflow: "scroll" }}>
              {" "}
              {data[index].ClientProgram}{" "}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Department :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Department Code :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Job Title:
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Bilingual :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>

            <Grid item xs={5} sx={{ marginTop: 10 }}></Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}></Grid>
          </Grid>
          <Grid item xs={4} container>
            <Grid item xs={5}>
              Start Time :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].StartTime}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Stop Time :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].StopTime}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Current Step/State :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].CurrentState} {data[index].CurrentStep}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Pref. First Name :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].FirstName}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Pref. Last Name :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].LastName}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Tech Equipment Solution :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].TechEquipmentSolution}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              ORT Status :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].ORTStatus != null
                ? data[index].ORTStatus === true
                  ? "Yes"
                  : "No"
                : null}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              ERT Due Date and <br />
              Time :
            </Grid>
            <Grid item xs={7} sx={{ marginTop: 10 }}>
              {data[index].ERTDueDate} {data[index].ERTDueTime}
            </Grid>
            <Grid item xs={5} sx={{ marginTop: 10 }}>
              Additional Comments :
            </Grid>
            <Grid
              item
              xs={7}
              sx={{ marginTop: 10, height: 50, overflow: "scroll" }}
            >
              {data[index].AdditionalComments}
            </Grid>
          </Grid>
        </Grid>
      ) : null}
    </>
  );
};

export default EmployeeDetails;
